export const actions = {
  FETCH_FOLLOWING_TEAMS: 'FETCH_FOLLOWING_TEAMS',
  SAVE_FOLLOWING_TEAMS: 'SAVE_FOLLOWING_TEAMS',
  SELECT_OBJECTIVE_VIEW: 'SELECT_OBJECTIVE_VIEW',
  FETCH_OBJECTIVE_CYCLE_LIST: 'FETCH_OBJECTIVE_CYCLE_LIST',
  SET_CYCLE_OR_CUSTOM_RANGE_DETAILS: 'SET_CYCLE_OR_CUSTOM_RANGE_DETAILS',
  GET_NOTIFICATION_BY_ID: 'GET_NOTIFICATION_BY_ID',
  SAVE_OBJECTIVE_CYCLE_LIST: 'SAVE_OBJECTIVE_CYCLE_LIST',
  SAVE_SELECTED_OBJECTIVE_CYCLE: 'SAVE_SELECTED_OBJECTIVE_CYCLE',
  SAVE_SELECTED_CYCLE_RANGE: 'SAVE_SELECTED_CYCLE_RANGE',
  SAVE_SELECTED_OBJECTIVE_CYCLE_BY_ID: 'SAVE_SELECTED_OBJECTIVE_CYCLE_BY_ID',
  SAVE_SELECTED_TEAM: 'SAVE_SELECTED_TEAM',
  GET_ALL_NOTIFICATION: 'GET_ALL_NOTIFICATION',
  SAVE_NOTIFICATIONS: 'SAVE_NOTIFICATIONS',
  SAVE_SINGLE_NOTIFICATION: 'SAVE_SINGLE_NOTIFICATION',
  SET_FILTERS: 'SET_FILTERS',
  CLEAR_FILTERS: 'CLEAR_FILTERS',
  MARK_NOTIFICATION_READ: 'MARK_NOTIFICATION_READ',
  MARK_ALL_NOTIFICATION_READ_FROM: 'MARK_ALL_NOTIFICATION_READ_FROM',
  SET_NOTIFICATION_LOADING: 'SET_NOTIFICATION_LOADING',
  SEND_HELP_QUERY: 'SEND_HELP_QUERY',
  GET_TASKS_FOR_CYCLE_ACTION: 'GET_TASKS_FOR_CYCLE_ACTION',
  SAVE_TASKS_ACTION: 'SAVE_TASKS_ACTION',
  UPDATE_TASK_STATUS_ACTION: 'UPDATE_TASK_STATUS_ACTION',
  UPDATE_SEARCH_QUERY_STRING_ACTION: 'UPDATE_SEARCH_QUERY_STRING_ACTION',
  SET_SHOW_COMPANY_OBJECTIVES: 'SET_SHOW_COMPANY_OBJECTIVES',
  SET_SHOW_INDEPENDENT_OBJECTIVES: 'SET_SHOW_INDEPENDENT_OBJECTIVES',
  SET_SHOW_DASHBOARD_FILTER_VIEW: 'SET_SHOW_DASHBOARD_FILTER_VIEW',
  SET_ADJACENT_QUARTER_TASKS_LOADING_STATUS:
    'SET_ADJACENT_QUARTER_TASKS_LOADING_STATUS',
  SET_LEVEL_FILTER_TOGGLE_VALUE: 'SET_LEVEL_FILTER_TOGGLE_VALUE',
  TOGGLE_PROTECTED_OBJECTIVES: 'TOGGLE_PROTECTED_OBJECTIVES',
  TOGGLE_CUSTOM_OBJECTIVES: 'TOGGLE_CUSTOM_OBJECTIVES',
  SET_LEVEL_FILTER_VALUE: 'SET_LEVEL_FILTER_VALUE',
  SET_DASHBOARD_FILTERS: 'SET_DASHBOARD_FILTERS',
  MARK_NOTIFICATION_AS_READ: 'MARK_NOTIFICATION_AS_READ',
  TOGGLE_CONTRIBUTOR_FILTER: 'TOGGLE_CONTRIBUTOR_FILTER',
  SET_TOGGLE_CONTRIBUTOR_FILTER: 'SET_TOGGLE_CONTRIBUTOR_FILTER'
};

export const fetchFollowingTeams = () => ({
  type: actions.FETCH_FOLLOWING_TEAMS
});

export const saveFollowingTeams = () => ({
  type: actions.SAVE_FOLLOWING_TEAMS
});

export const selectObjectiveView = () => ({
  type: actions.SELECT_OBJECTIVE_VIEW
});

export const fetchObjectiveCycleList = ({ selectedObjCycleId = null }) => ({
  type: actions.FETCH_OBJECTIVE_CYCLE_LIST,
  selectedObjCycleId
});

export const saveObjectiveCycleList = data => ({
  type: actions.SAVE_OBJECTIVE_CYCLE_LIST,
  data
});

export const saveSelectedObjectiveCycle = data => ({
  type: actions.SAVE_SELECTED_OBJECTIVE_CYCLE,
  data
});

export const saveSelectedCycleRange = data => ({
  type: actions.SAVE_SELECTED_CYCLE_RANGE,
  data
});

export const saveSelectedObjectiveCycleById = id => ({
  type: actions.SAVE_SELECTED_OBJECTIVE_CYCLE_BY_ID,
  id
});

export const saveSelectedTeam = data => ({
  type: actions.SAVE_SELECTED_TEAM,
  data
});

export const setFilters = filters => ({
  type: actions.SET_FILTERS,
  filters
});

export const setDashboardFilters = filters => ({
  type: actions.SET_DASHBOARD_FILTERS,
  filters
});

export const clearFilters = () => ({
  type: actions.CLEAR_FILTERS
});

export const getNotificationById = notificationId => ({
  type: actions.GET_NOTIFICATION_BY_ID,
  notificationId
});

export const getNotification = (requestBody, isOtherAction) => ({
  type: actions.GET_ALL_NOTIFICATION,
  requestBody,
  isOtherAction
});

export const saveSingleNotification = notification => ({
  type: actions.SAVE_SINGLE_NOTIFICATION,
  notification
});

export const saveNotification = (notifications, isOtherAction) => ({
  type: actions.SAVE_NOTIFICATIONS,
  notifications,
  isOtherAction
});

export const markNotificationRead = (notificationId, module) => ({
  type: actions.MARK_NOTIFICATION_READ,
  notificationId,
  module
});

export const markAllNotificationReadFrom = requestBody => ({
  type: actions.MARK_ALL_NOTIFICATION_READ_FROM,
  requestBody
});

export const setNotificationLoading = status => ({
  type: actions.SET_NOTIFICATION_LOADING,
  status
});

export const sendHelpQuery = (requestBody, successMessage) => ({
  type: actions.SEND_HELP_QUERY,
  requestBody,
  successMessage
});

export const getTasksForCycle = (oc = null) => ({
  type: actions.GET_TASKS_FOR_CYCLE_ACTION,
  oc
});

export const saveTasks = tasks => ({
  type: actions.SAVE_TASKS_ACTION,
  tasks
});

export const updateTaskStatus = (task_id, status, callback = null) => ({
  type: actions.UPDATE_TASK_STATUS_ACTION,
  task_id,
  status,
  callback
});

export const updateSearchQueryString = search_term => ({
  type: actions.UPDATE_SEARCH_QUERY_STRING_ACTION,
  search_term
});

export const setShowCompanyObjectives = showCompanyObjective => ({
  type: actions.SET_SHOW_COMPANY_OBJECTIVES,
  showCompanyObjective
});

export const setShowIndependentObjectives = toggleState => ({
  type: actions.SET_SHOW_INDEPENDENT_OBJECTIVES,
  toggleState
});
export const setLevelFilterToggleValue = status => ({
  type: actions.SET_LEVEL_FILTER_TOGGLE_VALUE,
  status
});

export const toggleProtectedObjectives = status => ({
  type: actions.TOGGLE_PROTECTED_OBJECTIVES,
  status
});

export const toggleCustomObjectives = status => ({
  type: actions.TOGGLE_CUSTOM_OBJECTIVES,
  status
});

export const setLevelFilterValue = value => ({
  type: actions.SET_LEVEL_FILTER_VALUE,
  value
});

export const markNotificationAsRead = notificationId => ({
  type: actions.MARK_NOTIFICATION_AS_READ,
  notificationId
});

export const setCycleOrCustomRangeDetails = () => ({
  type: actions.SET_CYCLE_OR_CUSTOM_RANGE_DETAILS
});

export const toggleContributorFilter = () => ({
  type: actions.TOGGLE_CONTRIBUTOR_FILTER
});

export const setToggleContributorFilter = value => ({
  type: actions.SET_TOGGLE_CONTRIBUTOR_FILTER,
  value
});
